import dayjs from "dayjs";

export function compareQuarterYearDateStrings(a: string, b: string) {
    const normalizedA = a.split(" ").reverse().join();
    const normalizedB = b.split(" ").reverse().join();

    return normalizedA.localeCompare(normalizedB);
}

export function getFormattedDate(currentDate: string, template: string = "MMMM YYYY") {
    return dayjs(currentDate).format(template);
}